// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609161134/js/" + chunkId + "." + {"44":"1da151cd","225":"b59182fd","481":"b2708378","486":"6b79a9df","770":"863ee315"}[chunkId] + ".0.8032999571360937.chunk.js";
};